import { Check } from '#components/Check'
import { log } from '#helpers'
import { endpoints, request, selectors, usePop, useTasks } from '#hooks'
import {
  Button,
  Disabled,
  Flex,
  Modal,
  Notice,
  PanelBody,
  PanelRow,
  RadioControl,
  Spinner,
  TextControl,
} from '@wordpress/components'
import { useState } from '@wordpress/element'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const FocusKeyword = ({ pop }) => {
  const { t } = useTranslation()
  const { tasks, isValidating, mutate } = useTasks(pop)
  const { post } = usePop(pop)
  const condition = tasks?.['targetkeyword']

  const [isOpen, setOpen] = useState(false)
  const [isWaiting, setIsWaiting] = useState(false)
  const openModal = () => setOpen(true)
  const closeModal = () => setOpen(false)

  const [option, setOption] = useState(null)
  const [options, setOptions] = useState([])

  const defaultValues = { keywords: '' }
  const { handleSubmit, control, setValue } = useForm({ defaultValues })

  const searchKeywords = (data) => {
    setIsWaiting(true)
    request(endpoints.keywordSearch.get(data))
      .then(({ data: { data, success } }) => {
        if (success) {
          setOptions(
            data.attributes.results.map((result) => ({
              label: result.name,
              value: result.name,
              id: result.id,
            }))
          )
        }
      })
      .finally(() => {
        setIsWaiting(false)
      })
      .catch(log)
  }

  const sendKeywords = (data) => {
    setIsWaiting(true)
    const result = options.find(({ value }) => value === data.keywords)
    request(
      endpoints.meta.create({
        postId: pop.id,
        data: {
          keyword: result.value,
          keywordId: result.id,
        },
      })
    )
      .finally(() => {
        setIsWaiting(false)
        closeModal()
        mutate()
      })
      .catch(log)
  }

  return (
    <PanelBody
      title={t('sidebar.focuskeyword.title')}
      icon={isValidating ? <Spinner /> : <Check condition={condition} />}
      initialOpen={!condition}
    >
      <PanelRow>
        <div>
          <p>{t('sidebar.focuskeyword.intro')}</p>
          {post?.postMetaFields?.[selectors.keyword]?.[0] ? (
            <div style={{ margin: '20px' }}>
              <Notice isDismissible={false}>
                {post?.postMetaFields?.[selectors.keyword]?.[0]}
              </Notice>
            </div>
          ) : null}
          <Button onClick={openModal} variant="primary">
            {t('sidebar.focuskeyword.cta')}
          </Button>
          {isOpen && (
            <Modal
              title={t('sidebar.focuskeyword.modal.title')}
              className="mktseo-modal--black"
              shouldCloseOnClickOutside={false}
              onRequestClose={closeModal}
            >
              <Flex direction="column" gap="5">
                <form onSubmit={handleSubmit(searchKeywords)}>
                  <Controller
                    name="keywords"
                    control={control}
                    render={({ field }) => (
                      <TextControl
                        label={t('sidebar.focuskeyword.modal.label')}
                        help={t('sidebar.focuskeyword.modal.help', {
                          title: post.title.rendered,
                        })}
                        {...field}
                      />
                    )}
                  />
                  <Disabled isDisabled={isWaiting}>
                    <Button type="submit" variant="primary">
                      {t('sidebar.focuskeyword.modal.cta')}
                    </Button>
                  </Disabled>
                </form>
                {isWaiting ? <Spinner /> : null}
                {options.length ? (
                  <RadioControl
                    label={t('sidebar.focuskeyword.modal.results.label')}
                    selected={option}
                    options={options}
                    onChange={(value) => {
                      setOption(value)
                      setValue('keywords', value)
                    }}
                  />
                ) : null}
                {option ? (
                  <Disabled isDisabled={isWaiting}>
                    <Button
                      variant="primary"
                      onClick={handleSubmit(sendKeywords)}
                    >
                      {t('sidebar.focuskeyword.modal.results.cta')}
                    </Button>
                  </Disabled>
                ) : null}
              </Flex>
            </Modal>
          )}
        </div>
      </PanelRow>
    </PanelBody>
  )
}
